"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function HomeIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "24px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style, className = _a.className;
    return (react_1.default.createElement("svg", { height: height, viewBox: "0 0 100 100", style: style, className: className },
        react_1.default.createElement("path", { d: "M23.84,89.83H41.2a4,4,0,0,0,4-4V69.27a5.16,5.16,0,1,1,10.31,0V85.83a4,4,0,0,0,4,4H76.88a8,8,0,0,0,8-8v-35l3.6,2.87a4,4,0,1,0,5-6.25L52.85,11a4,4,0,0,0-5,0L6.55,43.41a4,4,0,1,0,4.93,6.3l4.35-3.41V81.83A8,8,0,0,0,23.84,89.83Zm26.5-70.57L76.88,40.43v41.4H63.52V69.27a13.16,13.16,0,1,0-26.31,0V81.83H23.84V40Z", fill: color })));
}
exports.default = HomeIcon;
//# sourceMappingURL=index.js.map